import { Flex, Stepper } from '@servicetitan/anvil2';
import { ImperativeForm } from '@servicetitan/financing-application-shared';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';
import { RefObject, useCallback } from 'react';

interface PrequalificationButtonsProps {
    formRef: RefObject<ImperativeForm>;
    isNextButtonDisabled?: boolean;
    customFinalStepTitle?: string;
}

export const PrequalificationButtons = ({
    formRef,
    isNextButtonDisabled = false,
    customFinalStepTitle,
}: PrequalificationButtonsProps) => {
    const nextHandler = useCallback(async () => {
        await formRef.current?.submit();
        const { resolve, promise } = Promise.withResolvers<boolean>();
        // There is some sort of concurrency issue with the form validation
        // so we need to wait a bit before checking if the form is valid
        setTimeout(() => {
            if (formRef.current && !formRef.current.isValid()) {
                resolve(false);
            } else {
                resolve(true);
            }
        }, 0);
        return promise;
    }, [formRef]);

    const { CancelApplicationButton } = WorkflowButtonsStore.useStore();

    return (
        <Flex justifyContent="space-between" style={{ width: '100%' }} gap="4">
            <Flex gap="3" justifyContent="flex-end" grow={1} style={{ width: '100%' }}>
                <Stepper.PrevButton label="Back" />
                <CancelApplicationButton>Cancel</CancelApplicationButton>
                <Stepper.NextButton
                    nextLabel="Continue"
                    completeLabel={customFinalStepTitle ?? 'Continue'}
                    disabled={isNextButtonDisabled}
                    onClick={nextHandler as unknown as () => void}
                    style={customFinalStepTitle ? { width: '100%' } : undefined}
                />
            </Flex>
        </Flex>
    );
};
